<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="input-container" [class.disabled]="disabled">
  @if (label) {
    <label class="input-label">
      <hyperkit-typography variant="emphasized" size="sm" color="inherit">
        {{ label }}
        @if (isRequired) {
          <span class="required-asterisk">*</span>
        }
      </hyperkit-typography>
    </label>
  }
  <div
    class="input-wrapper"
    [class.focused]="isFocused"
    [class.error]="hasError"
    [class.disabled]="disabled"
    >
    <hyperkit-typography
      variant="body"
      size="md"
      color="primary"
      class="input-typography-wrapper"
      >
      <input
        #inputElement
        [type]="type"
        [value]="value"
        [attr.maxlength]="maxLength"
        [placeholder]="placeholder"
        [disabled]="disabled"
        (input)="onInput($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        class="input-field"
        />
    </hyperkit-typography>
    @if (rightIcon) {
      <hyperkit-icon
        [icon]="rightIcon"
        size="small"
        color="inherit"
        class="right-icon"
      ></hyperkit-icon>
    }
    @if (showClear && value) {
      <hyperkit-icon
        icon="x"
        size="small"
        color="inherit"
        class="right-icon"
        (click)="onCancel()"
      ></hyperkit-icon>
    }
  </div>

  @if (hint) {
    <div class="hint-container">
      <hyperkit-typography variant="body" size="sm" color="tertiary">
        {{ hint }}
      </hyperkit-typography>
    </div>
  }
  @if (errorMessage) {
    <div class="hint-container">
      <hyperkit-error [error]="errorMessage"></hyperkit-error>
    </div>
  }
</div>
